import { useState } from "react";
import { Check, Copy, Loader2, Tag, X } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg, useApi } from "@/lib/api";

const rm = (sen) => `RM${(sen / 100).toFixed(2)}`;

export const PromoInput = ({ produk, promo, setPromo }) => {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [kod, setKod] = useState("");
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try { const r = await api("post", "/billing/promo/check", { kod, produk }); setPromo(r); toast.success(`Kod ${r.kod} digunakan: ${rm(r.harga_sen)}`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (promo) return (
    <div className="text-xs inline-flex items-center gap-2 text-q" data-testid={`promo-applied-${produk}`}>
      <Tag size={12} /> Kod <strong>{promo.kod}</strong> · {rm(promo.harga_sen)}
      <button onClick={() => { setPromo(null); setKod(""); setOpen(false); }} aria-label="Buang kod" className="text-mute hover:text-warn" data-testid={`promo-remove-${produk}`}><X size={12} /></button>
    </div>
  );
  if (!open) return <button onClick={() => setOpen(true)} className="text-xs text-mute underline underline-offset-4 self-start hover:text-q" data-testid={`promo-toggle-${produk}`}>Ada kod promosi?</button>;
  return (
    <div className="flex gap-2">
      <input value={kod} onChange={(e) => setKod(e.target.value.toUpperCase())} placeholder="KOD PROMOSI" maxLength={30} data-testid={`promo-input-${produk}`}
        className="flex-1 h-9 px-3 rounded-lg bg-bg border border-line text-sm font-mono-data focus:outline-none focus:border-[var(--q)]" />
      <button onClick={check} disabled={busy || !kod.trim()} data-testid={`promo-apply-${produk}`}
        className="h-9 px-4 rounded-full border border-line text-xs font-semibold inline-flex items-center gap-1 hover:border-[var(--q)] disabled:opacity-40">
        {busy && <Loader2 size={12} className="animate-spin" />} Guna
      </button>
    </div>
  );
};

export const KuponDialog = ({ info, onClose }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => { try { await navigator.clipboard.writeText(info.kupon); setCopied(true); } catch { toast.error("Gagal salin; sila taip kod secara manual."); } };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="kupon-dialog">
        <DialogHeader><DialogTitle>Satu langkah lagi</DialogTitle></DialogHeader>
        <p className="text-sm text-mute">Di borang OnPay, masukkan kod ini di ruangan <strong className="text-ink">kupon</strong> supaya harga menjadi <strong className="text-ink">{rm(info.amount_sen)}</strong>. Gunakan emel yang sama dengan akaun ATAS anda.</p>
        <div className="flex items-center gap-2">
          <code className="flex-1 h-11 px-4 rounded-xl bg-surface border border-line font-mono-data text-lg tracking-widest grid items-center" data-testid="kupon-code">{info.kupon}</code>
          <button onClick={copy} className="h-11 px-4 rounded-full border border-line text-sm inline-flex items-center gap-2" data-testid="kupon-copy">{copied ? <Check size={14} /> : <Copy size={14} />} {copied ? "Disalin" : "Salin"}</button>
        </div>
        <button onClick={() => window.location.assign(info.url)} className="h-11 rounded-full bg-ink text-bg text-sm font-semibold" data-testid="kupon-continue">Teruskan ke OnPay</button>
      </DialogContent>
    </Dialog>
  );
};
